export default "__VITE_ASSET__BPbDcGM1__"